define(["require", "exports", "./context", "jquery"], function (require, exports, context_1, $) {
    "use strict";
    exports.__esModule = true;
    function getContactAboutProduct() {
        return {
            productLink: window.location.href,
            productName: $('head title').text()
        };
    }
    function fixFixedOnFocus() {
        if ('ontouchstart' in window) {
            $(document).on('focus', 'select, textarea', function () {
                $('.pop-up').toggleClass('hidden', true);
            }).on('blur', 'select, input, textarea', function () {
                $('.pop-up').toggleClass('hidden', false);
            });
        }
    }
    exports.fixFixedOnFocus = fixFixedOnFocus;
    function startContactAboutProduct(evt) {
        evt.preventDefault();
        evt.stopPropagation();
        var $popup = $('.contact-pop-up');
        var product = getContactAboutProduct();
        var body = '\n\nAbout product at \n\n' + product.productLink;
        var subject = 'Question about ' + product.productName;
        if (context_1["default"].isMobile()) {
            $popup.toggleClass('show', true);
            if ($popup.find('.close-button').length == 0) {
                $popup.append('<div class="close-button"></div>');
            }
            $popup.find('.icon-mail').attr('href', 'mailto:contact' + '@' + 'celuce.com?subject=' +
                encodeURIComponent(subject) +
                '&body=' + encodeURIComponent(body));
            $popup.find('.close-button').click(function () {
                $popup.toggleClass('show', false);
            });
        }
        else {
            window.location.href = 'mailto:contact' + '@' + 'celuce.com?subject=' +
                encodeURIComponent(subject) +
                '&body=' + encodeURIComponent(body);
        }
    }
    exports.startContactAboutProduct = startContactAboutProduct;
    function mobileContactUs(about) {
        var $popup = $('.contact-pop-up');
        $popup.toggleClass('show', true);
        if ($popup.find('.close-button').length == 0) {
            $popup.append('<div class="close-button"></div>');
        }
        $popup.find('.icon-mail').attr('href', 'mailto:contact' + '@' + 'celuce.com');
        $popup.find('.icon-bubble').attr('href', 'sms:+1425998' +
            '7813');
        $popup.find('.icon-phone').attr('href', 'tel:+1425998' + '7813');
        $popup.find('.close-button').click(function () {
            $popup.toggleClass('show', false);
        });
    }
    exports.mobileContactUs = mobileContactUs;
});



//////////////////
// WEBPACK FOOTER
// ./Scripts/built/contactus.js
// module id = 67
// module chunks = 0